import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
const Refresh = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2.25 12c0-5.424 4.23-9.75 9.363-9.75 3.382 0 6.365 1.87 8.014 4.704l-4.582-1.686-.777 2.112 8.474 3.118 1.25-8.676-2.228-.32-.54 3.758C19.14 2.097 15.623 0 11.613 0 5.16 0 0 5.411 0 12s5.161 12 11.613 12c4.95 0 9.148-3.194 10.826-7.649l.397-1.053-2.106-.793-.396 1.053c-1.374 3.646-4.777 6.192-8.72 6.192-5.134 0-9.364-4.326-9.364-9.75Z"
}), 'Refresh');
export { Refresh };
//# sourceMappingURL=Refresh.js.map